import { render, staticRenderFns } from "./director-notifications.vue?vue&type=template&id=68bd6fad&scoped=true&"
import script from "./director-notifications.vue?vue&type=script&lang=ts&"
export * from "./director-notifications.vue?vue&type=script&lang=ts&"
import style0 from "./director-notifications.vue?vue&type=style&index=0&id=68bd6fad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd6fad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSwitch,VTextField})
